<template>
    <div class="template-download">
        <div class="caution-info">
            选择“全部”是下载所有分类下的物资模板表格， 也可以选择制定某一分类下载物资模板表格
        </div>
        <div class="flex-child">
            <span class="input-label">选择分类： </span>
            <span class="Cascader">
                <Select v-model="department" multiple @on-change="departmentChange">
                    <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </span>
            <Button type="primary" :loading="downLoading" class="download-btn">
                <span v-if="!downLoading" @click="submitDownload" class="span">下载</span>
                <span v-else class="span">下载</span>
            </Button>
        </div>
        <Table :columns="columns12" :data="tableContents" id="Tool-test"></Table>
    </div>
</template>

<script>
import printJs from 'print-js';
import { queryProductByClassifyNos, queryProductClassify } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
import factory from '@/assets/js/ybTool.js';
import '@/assets/js/query.min.js';
import '@/assets/js/jszip.min.js';
import saveAs from '@/assets/js/FileSaver.js';
export default {
    data() {
        return {
            downLoading: false,
            // 选择分类
            department: [ '00' ],
            cityList: [
                {
                    value: '00',
                    label: '全部'
                }
            ],
            columns12: [
                {
                    title: 'SPU码',
                    key: 'productspu',
                    minWidth: 100,
                    className: 'td-text'
                },
                {
                    title: '物资名称',
                    key: 'productname',
                    minWidth: 150
                },
                {
                    title: '物资编码',
                    key: 'productno',
                    minWidth: 150
                },
                {
                    title: '分类名称',
                    key: 'classifyname',
                    minWidth: 100
                },
                {
                    title: '分类编码',
                    key: 'classifyno',
                    minWidth: 100,
                    className: 'td-text'
                },
                {
                    title: '物资规格',
                    key: 'productspectype',
                    minWidth: 100
                },
                {
                    title: '计量单位',
                    key: 'productspec',
                    minWidth: 100
                },
                {
                    title: '数量',
                    key: 'productCount',
                    minWidth: 100
                },
                {
                    title: '单价（元）',
                    key: 'unitPrice',
                    minWidth: 100
                },
                {
                    title: '金额（元）',
                    key: 'totalPrice',
                    minWidth: 100
                }
            ],
            tableContents: []
        };
    },

    mounted() {
        // this.getDownloadList();
        this.getProductClassify();
    },

    methods: {
        // 获取物资分类的联级列表
        getProductClassify() {
            this.$apollo.query({
                query: queryProductClassify,
                variables: {
                    cliqueNo: `${Cookies.getJSON('cliqueNo')}`,
                    supplierNo: `${Cookies.getJSON('USER-INFO').supplierNo}`
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductClassify;
                if (data && data.data && data.code === 200) {
                    let parentData = data.data['1'];
                    parentData.forEach(ele => {
                        let classifyName, classifyNo, value, label;
                        ({ classifyName: label, classifyNo: value } = ele);
                        this.cityList.push({
                            value,
                            label
                        });
                    });
                } else {
                    this.$setNotice('分类列表获取失败，刷新试试吧');
                }
            });
        },

        // 多选获取数据
        departmentChange(val) {
            if (val.length > 1) {
                if (val.includes('00')) {
                    this.department = val.filter(x => x !== '00');
                } else {
                    this.department = val;
                }
            } else if (val.length === 1) {
                this.department = val;
            } else {
                this.department = ['00'];
            }
        },

        // 提交下载需求
        submitDownload() {
            this.downLoading = true;
            let vari = {
                cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                supplierNo: Cookies.getJSON('USER-INFO').supplierNo
            };
            if (this.department.length > 1) {
                vari.classifyNos = this.department.filter(x => x !== '00');
            } else if (this.department.length === 1) {
                if (!this.department.includes('00')) {
                    vari.classifyNos = this.department;
                }
            } else {
                this.$setNotice('请选择模板');
                return;
            }
            document.querySelector('#Tool-test .ivu-table-tip tbody td span').innerText = ' ';
            this.$apollo.query({
                query: queryProductByClassifyNos,
                variables: vari,
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductByClassifyNos;
                if (data && data.data && data.code === 200) {
                    this.tableContents = JSON.parse(data.data);
                    if (this.tableContents.length) {
                        setTimeout(() => {
                            document.querySelector('#Tool-test .ivu-table-tip tbody td span').innerText = ' ';
                            // 模板下载，文件名可自定义
                            factory().excelExport({
                                'src_id': 'Tool-test',
                                'type': 'table',
                                'show_header': true
                            }, '单据模板');
                        }, 500);
                        this.department = ['00'];
                        this.downLoading = false;
                    } else {
                        this.$setNotice('您要下载的模板不存在');
                        this.downLoading = false;
                    }
                }
            });
        }
    }
};
</script>

<style lang="stylus">

@import '../assets/stylus/views/template-download.styl'

</style>



// WEBPACK FOOTER //
// src/views/TemplateDownload.vue